export default __webpack_public_path__ + "static/media/acc-plus-icon.5cc142f3.svg";